export enum TimeEntrySubTypeKey {
  CEI_MISCELLANEOUS = 'cei_miscellaneous',
  CEI_TRAINING_WORKSHOPS = 'cei_training_workshops',
  CEI_INTERNAL_MEETINGS = 'cei_internal_meetings',
  CEI_RESEARCH = 'cei_research',
  CEI_PROCESS_IMPROVEMENT = 'cei_process_improvement',
  CEI_WORKING_WITH_SALES = 'cei_working_with_sales',
  CEI_ADMIN_TASKS_JEPS = 'cei_admin_tasks_jeps',
  CEI_WORKING_WITH_PRODUCT = 'cei_working_with_product',
  CEI_IT_ISSUES = 'cei_it_issues',
  CEI_WORKING_WITH_FINANCE = 'cei_working_with_finance',
  CEI_WORKING_WITH_PARTNERS = 'cei_working_with_partners',
  CEI_PLATFORM_NOTIFICATIONS = 'cei_platform_notifications'
}
